import { setLocalStorage } from "./handlingStorage";
import { isLoggedIn } from "./helper";
import {unlockArticles} from "./unlockArticles";

const iwwDomain = process.env.IWW_DOMAIN

document.addEventListener('DOMContentLoaded', function () {
    let togglepassword = document.getElementById('toggle-password');
    let passwordField = document.getElementById('login-form-password');

    // toggle Passwort-Sichtbarkeit wenn Loginform vorhanden ist
    if(togglepassword && passwordField)
    {
        togglepassword.addEventListener('click', function () {
        passwordField.type = passwordField.type === 'password' ? 'text' : 'password';
        // Toggle Icon des Passwort-sichtbar-Feldes
        if (passwordField.type === 'password') {
            togglepassword.classList.add('before:content-eye-off');
        } else {
            togglepassword.classList.remove('before:content-eye-off');
            togglepassword.classList.remove('cursor-pointer');
            togglepassword.classList.add('before:content-eye');
        }
        });
    }

    // Button des Loginformulares erst aktivieren wenn Formular ausgefuellt ist
    const form = document.getElementById('login-form');
    const submitButton = document.getElementById('login-form-button-submit');

    if(form && submitButton)
    {
        // Funktion zur Überprüfung der Formularvalidität
        form.addEventListener('input', function () {
            if (form.checkValidity()) {
                submitButton.classList.add('bg-gradient-to-r', 'from-buttongradientlight', 'from-39%', 'to-buttongradientdark', 'to-86%', 'hover:cursor-pointer', 'transition-all', 'duration-200', 'ease-in-out', 'hover:scale-105', 'hover:shadow-big');
                submitButton.classList.remove('bg-neutral-100', 'opacity-10', 'cursor-auto');
            } else {
                submitButton.classList.remove('bg-gradient-to-r', 'from-buttongradientlight', 'from-39%', 'to-buttongradientdark', 'to-86%', 'hover:cursor-pointer', 'transition-all', 'duration-200', 'ease-in-out', 'hover:scale-105', 'hover:shadow-big');
                submitButton.classList.add('bg-neutral-100', 'opacity-10', 'cursor-auto');
            }
        });
    }

    // Fehlermeldungen anzeigen
    let url = new URL(window.location);
    let error = url.searchParams.has("error");
    if(error)
    {
        const username = document.getElementById('login-form-username');
        const password = document.getElementById('login-form-password');
        if(username)
        {
            username.classList.remove('bg-gray-50', 'border-neutral-10', 'text-neutral-100', 'focus:ring-highlight-100', 'focus:border-highlight-100');
            username.classList.add('bg-red-100', 'border-red-300', 'text-red-700', 'focus:ring-red-700', 'focus:border-red-700');
        }
        if(username)
        {
            password.classList.remove('bg-gray-50', 'border-neutral-10', 'text-neutral-100', 'focus:ring-highlight-100', 'focus:border-highlight-100');
            password.classList.add('bg-red-100', 'border-red-300', 'text-red-700', 'focus:ring-red-700', 'focus:border-red-700');
        }

    }

})


// Wenn Cookie gesetzt ist, soll MainMenuLoggedin angezeigt werden ueberschrieben werden
if(isLoggedIn())
{
    const user = IwwUserdata.USERDATA;

    if(document.getElementById('iww-mainheader-loggedin-username')){
        document.getElementById('iww-mainheader-loggedin-username').innerText = user.vorname + " "+ user.nachname ;
    }

    let list = document.getElementById('iww-mainheader-loggedin-abos');
    if(list){
        for(let i = 0; i < user.infodienste.length; i++) {
            let entry = document.createElement("li");
            entry.classList.add("mr-5","group");
            let link = document.createElement("a");
            link.href = iwwDomain + user.infodienste[i].toLowerCase();
            link.innerText = user.infodienste[i];
            link.classList.add("text-base", "text-neutral-60", "relative", "hover:text-neutral-100");
            entry.appendChild(link);
            list.appendChild(entry);
        }
    }


    document.addEventListener('DOMContentLoaded', function (event) {
        unlockArticles();
    });
    document.addEventListener('htmx:afterSettle', function (event) {
        unlockArticles();
    });
}

if (window.location.href.includes("/logout")) {
    setLocalStorage("logged_in", 0)
}
